import { forTemplate } from '@trello/i18n';
import type { ReactNode, FunctionComponent } from 'react';
import React from 'react';
import styles from './WorkspaceSettingsSection.less';

const format = forTemplate('org_account');

interface WorkspaceSettingsSectionProps {
  title: string;
  detail: ReactNode;
  action: ReactNode;
  isEditable?: boolean;
  restrictionMessage?: ReactNode;
}

export const WorkspaceSettingsSection: FunctionComponent<WorkspaceSettingsSectionProps> = ({
  title,
  detail,
  action,
  isEditable = true,
  restrictionMessage,
}) => {
  return (
    <div className={styles.workspaceSettingsSection}>
      <div className={styles.title}>
        <h3>{title}</h3>
      </div>
      <div className={styles.settingItem}>
        <div className={styles.settingItemDetail}>
          {detail}
          {!isEditable && (
            <div className={styles.adminMessage}>
              {restrictionMessage
                ? restrictionMessage
                : format('you-need-to-be-an-admin-to-change-this-setting')}
            </div>
          )}
        </div>
        <div className={styles.settingItemAction}>{action}</div>
      </div>
    </div>
  );
};
